import { useEffect, useState } from "react";

const BASE = process.env.REACT_APP_BACKEND_URL;
let cache = null;
let inflight = null;

/** Dados legais públicos (identificação do vendedor, RAL, Livro de Reclamações). */
export function useLegal() {
  const [data, setData] = useState(cache);
  useEffect(() => {
    if (cache) return;
    inflight =
      inflight ||
      fetch(`${BASE}/api/legal`)
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null);
    inflight.then((d) => {
      if (d) cache = d;
      setData(d);
    });
  }, []);
  return data;
}
